import { useState, useEffect } from 'react';

export function useDeviceType() {
  const [device, setDevice] = useState('desktop');

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      if (width > height) {
        setDevice('tablet');
      } else {
        setDevice('mobile');
      }
      // if (width < 720) {
      //   setDevice("mobile");
      // } else if (width >= 720 && width < 1024) {
      //   setDevice("tablet");
      // } else {
      //   setDevice("desktop");
      // }
    };

    checkDevice(); // Set initially
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return device;
}
